import { render, staticRenderFns } from "./TrailerPopup.vue?vue&type=template&id=bb312c1c&scoped=true"
import script from "./TrailerPopup.vue?vue&type=script&lang=ts"
export * from "./TrailerPopup.vue?vue&type=script&lang=ts"
import style0 from "./TrailerPopup.vue?vue&type=style&index=0&id=bb312c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb312c1c",
  null
  
)

export default component.exports